import { Link } from "react-router-dom";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import { MdRadio, MdDescription } from "react-icons/md";
import { VscTypeHierarchySub } from "react-icons/vsc";
import { MdCategory } from "react-icons/md";
import { TbLanguage } from "react-icons/tb";
import { IoMdPricetags } from "react-icons/io";
import { Badge } from "reactstrap";
import { HiPuzzle } from "react-icons/hi";
import "./emissionCard.scss";

const EmissionCard = (props) => {
  const { activeView, item, t } = props;
  const shareUrl = window.location.origin;

  return (
    <div
      className={
        activeView === "list"
          ? "featured_artist_list shop_video_wrapper shop_list_img_wrapper ms_cover EmissionCardContainerListView"
          : "featured_artist_list shop_video_wrapper  ms_cover EmissionCardContainerCardView"
      }
    >
      <img
        height="250px"
        className="img-responsive"
        src={item.picture}
        alt={item.id}
      />

      <div
        className={`featured_artist_detail shop_featured_artist${
          activeView != "list" ? "emissionCardView" : ""
        }`}
      >
        <span className="cardPropContainer">
          <MdRadio size={30} />
          <p>
            <Link to={`/emission/${item.id}`}>{item.name}</Link>
          </p>
        </span>
        <span className="cardPropContainer">
          <MdDescription />
          <p
            style={{ maxWidth: "350px" }}
            className="various_artist_text text-truncate"
          >
            {t("Description :")} {item.description}
          </p>
        </span>
        <span className="cardPropContainer">
          <VscTypeHierarchySub />
          <p>
            {t("Classification")}:
            <Link
              to={`/emissions/classification/${item?.classification?.id}/${item?.classification?.name}`}
            >
              <Badge
                className="ms-1 "
                color="warning"
                style={{ fontSize: "12px" }}
              >
                {item?.classification?.name}
              </Badge>
            </Link>
          </p>
        </span>
        <span className="cardPropContainer">
          <TbLanguage />
          <p>
            {t("Language")} : {item.language?.name}
          </p>
        </span>

        <div className="EmissionbadgesProp">
          <span className="EmissionPropNameBadges">
            <MdCategory /> <p>{t("Categories")} </p>
          </span>

          <span className="EmissionbadgesContainer">
            {item.categories?.map((el, i) => (
              <Link key={i} to={`/emissions/category/${el.slug}`}>
                <Badge
                  className="ms-1 tagEmission"
                  color="light-primary"
                  style={{ fontSize: "12px" }}
                >
                  {el.name}
                </Badge>
              </Link>
            ))}
          </span>
        </div>
        <div className="EmissionbadgesProp">
          <span className="EmissionPropNameBadges">
            <IoMdPricetags /> <p>{t("Tags")} </p>
          </span>

          <span className="EmissionbadgesContainer">
            {item?.tags?.map((el, i) => (
              <Link key={i} to={`/emissions/tag/${el.slug}`}>
                <Badge
                  className="ms-1 tagEmission"
                  color="light-secondary"
                  style={{ fontSize: "12px" }}
                >
                  {el.name}
                </Badge>
              </Link>
            ))}
          </span>
        </div>

        <div className="EmissionbadgesProp">
          <span className="EmissionPropNameBadges">
            <HiPuzzle />{" "}
            <p>
              {t("Episodes")}: {item?.episodes?.length}{" "}
            </p>
          </span>
        </div>

        <div className="socialMedia">
          <ul className="blog-icon-podcast" style={{ textAlign: "center" }}>
            <li>
              <FacebookShareButton url={`${shareUrl}/emission/${item.id}`}>
                <FacebookIcon size={20} round={true} />
              </FacebookShareButton>
            </li>

            <li>
              <TwitterShareButton url={`${shareUrl}/emission/${item.id}`}>
                <TwitterIcon size={20} round={true} />
              </TwitterShareButton>
            </li>
            <li>
              <WhatsappShareButton url={`${shareUrl}/emission/${item.id}`}>
                <WhatsappIcon size={20} round={true} />
              </WhatsappShareButton>
            </li>
            <li>
              <FacebookMessengerShareButton
                url={`${shareUrl}/emission/${item.id}`}
              >
                <FacebookMessengerIcon size={20} round={true} />
              </FacebookMessengerShareButton>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default EmissionCard;
